export default __webpack_public_path__ + "static/media/back-btn-blk-arrow-icon.d5fadb99.svg";